import { render, staticRenderFns } from "./AppScroll.vue?vue&type=template&id=42bfb638&scoped=true"
import script from "./AppScroll.vue?vue&type=script&lang=js"
export * from "./AppScroll.vue?vue&type=script&lang=js"
import style0 from "./AppScroll.vue?vue&type=style&index=0&id=42bfb638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bfb638",
  null
  
)

export default component.exports